const STORAGE_KEY = 'saloni_product_views_logged_v2';
const MAX_KEYS = 400;

export function productViewDedupeKey(categorySlug, productId, viewSource = '') {
  const src = String(viewSource || '').trim();
  return `${String(categorySlug || '').trim()}:${String(productId || '').trim()}:${src}`;
}

function readLoggedKeys() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.filter(Boolean) : [];
  } catch {
    return [];
  }
}

function writeLoggedKeys(keys) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(keys.slice(-MAX_KEYS)));
  } catch {
    /* ignore */
  }
}

export function hasLoggedProductView(categorySlug, productId, viewSource = '') {
  const key = productViewDedupeKey(categorySlug, productId, viewSource);
  if (!key || key.startsWith(':')) return false;
  return readLoggedKeys().includes(key);
}

export function markProductViewLogged(categorySlug, productId, viewSource = '') {
  const key = productViewDedupeKey(categorySlug, productId, viewSource);
  if (!key || key.startsWith(':')) return false;
  const keys = readLoggedKeys();
  if (keys.includes(key)) return false;
  keys.push(key);
  writeLoggedKeys(keys);
  return true;
}
